import { usePrepareCart } from '@cannect/hooks/usePrepareCart'
import { BRANDS_WITH_REQUIRED_FREIGHT } from '@cannect/utils/constants'
import {
  formatDateBR,
  getCartSplitDeliveryEstimateTexts,
  orderHasPillItem,
  PILL_DELIVERY_CEP_TEXT
} from '@cannect/utils/deliveryEstimate'
import { CircleAlert } from 'lucide-react'
import React from 'react'

interface WarningBannersProps {
  containsProductWithLongerDeliveryTime: boolean
  containProductsMatirz: boolean
  containsProductWithHubDistributor: boolean
  isPillOnly: boolean
}

const formatEstimatedRangeText = (start?: string | null, end?: string | null) => {
  if (!start || !end) return null

  return `A entrega estimada é entre ${formatDateBR(start)} e ${formatDateBR(end)}.`
}

export const WarningBanners: React.FC<WarningBannersProps> = ({
  containsProductWithLongerDeliveryTime,
  containProductsMatirz,
  containsProductWithHubDistributor,
  isPillOnly
}) => {
  const { lastOrderCreated, validatingDeliveryCep } = usePrepareCart()

  const isAllSupplements = lastOrderCreated?.items.every(
    (item: any) =>
      item?.product?.class_id === 6 && !BRANDS_WITH_REQUIRED_FREIGHT.includes(item?.product?.brand_id || item?.brand_id)
  )
  const estimatedRangeText = formatEstimatedRangeText(
    lastOrderCreated?.estimated_delivery_range_start,
    lastOrderCreated?.estimated_delivery_range_end
  )
  const splitEstimateTexts = getCartSplitDeliveryEstimateTexts(lastOrderCreated)
  const hasPillItem = orderHasPillItem(lastOrderCreated)
  return (
    <div className="space-y-2">
      {lastOrderCreated?.items?.some((item: any) => item?.requires_controlled_prescription) && (
        <div className="flex h-auto w-full items-center gap-4 rounded-md border border-blue-200 bg-[#B7C5F680] px-4 py-2.5">
          <div className="flex h-4 w-4 items-center justify-center rounded-xl">
            <CircleAlert className="h-4 w-4 text-information-300" />
          </div>
          <p className="text-xs font-normal text-information-300">
            <span className="font-bold">ATENÇÃO:</span> Confira se o produto e a quantidade inseridos correspondem à sua
            prescrição médica. Você pode realizar uma compra parcial, mas não deve ultrapassar o limite máximo indicado
            na receita. Em caso de dúvidas, consulte seu médico.
          </p>
        </div>
      )}

      {/* Card IMPORTANTE */}
      {!isAllSupplements && (
        <div className="flex h-auto min-h-16 w-full items-center gap-4 rounded border border-yellow-200 bg-[#FFEEC299] px-4 py-2.5 sm:min-h-12">
          <div className="flex h-4 w-4 items-center justify-center rounded-full">
            <CircleAlert className="h-4 w-4 text-neutral-500" />
          </div>
          {validatingDeliveryCep ? (
            <div className="flex items-center gap-2">
              <span
                className="animate-spin"
                style={{
                  display: 'inline-block',
                  width: 14,
                  height: 14,
                  border: '2px solid rgba(0,0,0,0.15)',
                  borderLeftColor: '#e6a817',
                  borderRadius: '50%',
                  flexShrink: 0
                }}
              />
              <p className="text-xs font-normal text-[#898483]">
                <span className="font-bold">IMPORTANTE:</span> Calculando estimativa de entrega...
              </p>
            </div>
          ) : splitEstimateTexts ? (
            <div className="flex flex-col gap-1">
              {splitEstimateTexts.map((text, index) => (
                <p key={text} className="text-xs font-normal text-[#898483]">
                  {index === 0 ? (
                    <>
                      <span className="font-bold">IMPORTANTE:</span> {text}
                    </>
                  ) : (
                    text
                  )}
                </p>
              ))}
            </div>
          ) : (
            <p className="text-xs font-normal text-[#898483]">
              <span className="font-bold">IMPORTANTE:</span>{' '}
              {(() => {
                if (estimatedRangeText) {
                  return estimatedRangeText
                }
                if (hasPillItem) {
                  return PILL_DELIVERY_CEP_TEXT
                }
                if (containsProductWithLongerDeliveryTime) {
                  return 'Existem produtos com possível maior tempo de entrega.'
                }
                if (containProductsMatirz) {
                  return 'O prazo de entrega é de 25 dias úteis a partir da confirmação do pagamento.'
                }
                if (containsProductWithHubDistributor) {
                  return 'O prazo de entrega é de 15 dias úteis a partir da confirmação do pagamento.'
                }
                return ''
              })()}
            </p>
          )}
        </div>
      )}
    </div>
  )
}
